import { AxDropdown } from "@axess/limestone";
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { CompPackOrderLessonValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderLessonValues";
import { Lesson } from "../../../Models/Lesson/Lesson";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";

@ModuleName("CompPackBookingLessonOptions")
export class CompPackBookingLessonOptions implements AxInit {
    protected complexPackageBookingOptions: ComplexPackageBookingOptions;
    private lessonSelectionDropdown: AxDropdown = new AxDropdown();

    AxInit(init: initData): void {
        this.complexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>("ComplexPackageBookingOptions");
        const lessonOrderValues: Lesson[] = JSON.parse(init.lessonOrderValues !== '' ? init.lessonOrderValues : '[]');

        lessonOrderValues.forEach((lesson: Lesson) => this.addTimeSlotSelectListener.call(this, lesson));
    }

    // addTimeSlotSelectListener
    addTimeSlotSelectListener(lesson: Lesson) {
        const opener = $('#optionTimeslotSelectButton');

        if (opener.length > 0) {
            this.lessonSelectionDropdown.init('#optionTimeslotSelectButton', {
                searchBar: false,
                multiSelect: false,
                onSelect: () => {
                    const $target = this.lessonSelectionDropdown.getSelected();

                    const lessonsNr = Number($target.attr("data-lessonsNr"));
                    const lessonWebNr = Number($target.attr("data-lessonWebNr"));
                    const lessonArcNr = Number($target.attr("data-lessonArcNr"));
                    const lessonDefNr = Number($target.attr("data-lessonDefNr"));
                    const packagePositionNr = Number($target.attr("data-packagePositionNr"));

                    this.addLessonValues(lessonsNr, lessonWebNr, lessonArcNr, lessonDefNr, packagePositionNr);
                }
            });
        } else {
            this.addLessonValues(lesson.lessonsNr, lesson.lessonWebNr, lesson.lessonArcNr, lesson.lessonDefNr, lesson.packagePositionNr);
        }
    }

    // addRentalValues
    addLessonValues(lessonsNr: number, lessonWebNr: number, lessonArcNr: number, lessonDefNr: number, packagePositionNr: number) {
        const lessonValues = new CompPackOrderLessonValues(lessonsNr, lessonWebNr, lessonArcNr, lessonDefNr, packagePositionNr);
        this.complexPackageBookingOptions.bookingValues.lessonOrderValues.push(lessonValues);
    }
}

export interface initData {
    lessonOrderValues: string;
}